import { Time } from "../../../tables/transactions-table/data/types"
import BodyItem from "./BodyItem"

const DateInfo = ({
	time: {
		formatted: { time, date },
	},
	dateAlternativeTitle,
	timeAlternativeTitle,
}: {
	time: Time
	dateAlternativeTitle?: string
	timeAlternativeTitle?: string
}) => {
	return (
		<>
			{date && (
				<BodyItem
					name={dateAlternativeTitle ? dateAlternativeTitle : "Fecha"}
					value={date}
				/>
			)}
			{time && (
				<BodyItem
					name={timeAlternativeTitle ? timeAlternativeTitle : "Hora"}
					value={time}
				/>
			)}
		</>
	)
}

export default DateInfo
